import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { IMAGES } from "../data/content";

// Editorial article card. variant: "featured" | "large" | "default" | "compact"
export default function ArticleCard({ article, variant = "default", index = 0, testId }) {
  const img = IMAGES[article.image];

  if (variant === "featured") {
    return (
      <Link to={`/insights/${article.slug}`} data-testid={testId} className="group block">
        <div className="grid overflow-hidden rounded-3xl border border-[#111827]/8 bg-white shadow-[0_30px_70px_-45px_rgba(17,24,39,0.4)] lg:grid-cols-2">
          <div className="img-overlay-blue relative min-h-[280px] overflow-hidden">
            <img src={img} alt={article.title} className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" loading="lazy" />
          </div>
          <div className="flex flex-col justify-center p-8 lg:p-12">
            <div className="flex items-center gap-3 text-xs font-semibold uppercase tracking-wider">
              <span className="text-[#1677FF]">{article.category}</span>
              {article.isExample && <Badge />}
            </div>
            <h3 className="mt-4 text-2xl font-extrabold leading-tight text-[#111827] lg:text-3xl">{article.title}</h3>
            <p className="mt-4 text-base leading-relaxed text-[#4B5563]">{article.subtitle}</p>
            <div className="mt-6 flex items-center gap-4 text-xs text-[#6B7280]">
              <span>{article.date}</span><span>·</span><span>{article.readTime}</span>
            </div>
            <span className="group mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#1677FF]">
              Read article <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </span>
          </div>
        </div>
      </Link>
    );
  }

  const large = variant === "large";
  return (
    <Reveal index={index % 3}>
      <Link to={`/insights/${article.slug}`} data-testid={testId} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-[#111827]/8 bg-white transition-all duration-400 hover:-translate-y-1 hover:shadow-[0_24px_50px_-28px_rgba(17,24,39,0.35)]">
        <div className="img-overlay-blue relative overflow-hidden">
          <img src={img} alt={article.title} className={`w-full object-cover transition-transform duration-700 group-hover:scale-105 ${large ? "h-64" : "h-48"}`} loading="lazy" />
        </div>
        <div className="flex flex-1 flex-col p-6">
          <div className="flex items-center gap-2 text-xs font-semibold uppercase tracking-wider">
            <span className="text-[#1677FF]">{article.category}</span>
            {article.isExample && <Badge />}
          </div>
          <h3 className={`mt-3 font-extrabold leading-snug text-[#111827] ${large ? "text-xl lg:text-2xl" : "text-lg"}`}>{article.title}</h3>
          <p className="mt-2 flex-1 text-sm leading-relaxed text-[#4B5563]">{article.excerpt}</p>
          <div className="mt-5 flex items-center justify-between border-t border-[#111827]/8 pt-4 text-xs text-[#6B7280]">
            <span>{article.date} · {article.readTime}</span>
            <ArrowRight className="h-4 w-4 text-[#9CA3AF] transition-all group-hover:translate-x-1 group-hover:text-[#1677FF]" />
          </div>
        </div>
      </Link>
    </Reveal>
  );
}

function Badge() {
  return (
    <span className="rounded-full border border-[#FF6A45]/30 bg-[#FF6A45]/10 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-[#FF6A45]">
      Example
    </span>
  );
}
